
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Kondhwatomumbaicab() {



    const cardData =
    {
        keyword: 'Kondhwa to Mumbai Cab',
        heading: 'Skyline Cabs: Kondhwa to Mumbai Cab',
        headingDescription: 'Skyline Cabs provides reliable and comfortable Kondhwa to Mumbai Cab services. Whether you are planning a business trip, family outing, or need an airport transfer, our clean, well-maintained cabs and professional drivers ensure a smooth and timely journey. Enjoy a hassle-free travel experience with affordable fares, punctual service, and 24/7 customer support. Book your Kondhwa to Mumbai cab with Skyline Cabs today for a safe and pleasant ride.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],

"services": [
    {
      "name": "Kondhwa to Mumbai Cab Fare",
      "description": "Skyline Cabs offers affordable and transparent fare pricing for cabs from Kondhwa to Mumbai. With competitive rates, our taxis ensure a comfortable and reliable journey to your destination."
    },
    {
      "name": "Kondhwa to Mumbai Airport Cab",
      "description": "Book a cab with Skyline Cabs for a hassle-free ride from Kondhwa to Mumbai Airport. We provide a variety of vehicle options like Innova and Ertiga for a comfortable and timely airport drop."
    },
    {
      "name": "Kondhwa to Navi Mumbai Cab",
      "description": "Skyline Cabs provides prompt and reliable taxi services from Kondhwa to Navi Mumbai. Choose from a range of vehicles for a smooth, hassle-free ride."
    },
    {
      "name": "Cab Service In Kondhwa",
      "description": "Skyline Cabs offers professional taxi services in Kondhwa, Pune. Whether you're traveling locally or to Mumbai, we provide a variety of vehicles for your convenience and comfort."
    },
    {
      "name": "NIBM Road to Mumbai Cab",
      "description": "Skyline Cabs offers convenient and reliable taxi services from NIBM Road to Mumbai. Choose from a range of comfortable vehicles like Swift Dzire, Etios, or Innova for a smooth journey."
    },
    {
      "name": "NIBM Road to Mumbai Airport Cab",
      "description": "For a comfortable and timely ride from NIBM Road to Mumbai Airport, book a cab with Skyline Cabs. Our experienced drivers ensure you arrive on time, with a variety of vehicle options to choose from."
    },
    {
      "name": "Cab Service in NIBM Road",
      "description": "Skyline Cabs provides reliable taxi services on NIBM Road, Pune. Whether you need a local ride or an outstation trip, our professional drivers will ensure a smooth and safe journey."
    },
    {
      "name": "Cabs Service Undri Road",
      "description": "Skyline Cabs offers dependable and affordable taxi services on Undri Road, Pune. From local rides to Mumbai trips, our fleet of vehicles is available for all your travel needs."
    },
    {
      "name": "Taxi Service in Undri Pune",
      "description": "Skyline Cabs offers reliable and professional taxi services in Undri, Pune. Whether you're looking for a local ride or planning a trip to Mumbai, we provide a range of vehicles for your comfort."
    },
    {
      "name": "Taxi Service Katraj",
      "description": "Skyline Cabs offers taxi services in Katraj, Pune. From local transfers to long-distance trips, our cabs ensure a safe and comfortable journey at affordable rates."
    },
    {
      "name": "Katraj to Mumbai Cab Service",
      "description": "Skyline Cabs provides reliable and timely cab services from Katraj to Mumbai. Whether for business or leisure, our fleet of vehicles ensures a comfortable and hassle-free journey."
    },
    {
      "name": "Katraj to Mumbai Airport Cab Service",
      "description": "For a smooth and timely airport transfer from Katraj to Mumbai, choose Skyline Cabs. Our fleet includes vehicles like Innova and Ertiga for a comfortable ride."
    },
    {
      "name": "Kondhwa to Bandra Cab Service",
      "description": "Skyline Cabs offers reliable cab services from Kondhwa to Bandra, Mumbai. Enjoy a comfortable journey with a choice of vehicles including Innova and Ertiga."
    },
    {
      "name": "Kondhwa to Dadar Cab Service",
      "description": "Skyline Cabs provides comfortable and reliable cab services from Kondhwa to Dadar, Mumbai. Our fleet includes a range of vehicles, including premium options like the Innova for a comfortable ride."
    },
    {
      "name": "Kondhwa to Mumbai Airport Cabs",
      "description": "For a convenient airport transfer from Kondhwa to Mumbai, book a cab with Skyline Cabs. Our fleet includes Innova, Ertiga, and more, ensuring a smooth and timely ride to the airport."
    },
    {
      "name": "Cab Service in Kondhwa Pune",
      "description": "Skyline Cabs provides professional and dependable cab services in Kondhwa, Pune. Our fleet includes a variety of vehicles to suit your travel needs, ensuring a safe and comfortable journey."
    },
    {
      "name": "Skyline Cabs Pune",
      "description": "Skyline Cabs offers reliable and affordable taxi services in Pune. We cater to local and outstation trips, with a fleet of well-maintained vehicles for your comfort and convenience."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Skyline Cabs offers seamless and timely taxi services from Pune to Mumbai Airport. We provide a variety of vehicles, including Innova and Ertiga, for a comfortable airport transfer."
    },
    {
      "name": "Pune Mumbai Cab",
      "description": "Skyline Cabs provides reliable and affordable cab services for travel between Pune and Mumbai. Whether you need a one-way trip or round-trip service, we ensure a smooth and comfortable journey."
    },
    {
      "name": "Kondhwa to Outstation Cab Service",
      "description": "Skyline Cabs offers convenient outstation cab services from Kondhwa to various destinations. Whether it's a weekend getaway or a longer trip, we provide well-maintained vehicles for a comfortable ride."
    }
  ],
  "tableData": [
    ["Kondhwa to Mumbai Cab Fare", "Kondhwa to Mumbai Airport Cab"],
    ["Kondhwa to Navi Mumbai Cab", "Cab Service In Kondhwa"],
    ["NIBM Road to Mumbai Cab", "NIBM Road to Mumbai Airport Cab"],
    ["Cab Service in NIBM Road", "Cabs Service Undri Road"],
    ["Taxi Service in Undri Pune", "Taxi Service Katraj"],
    ["Katraj to Mumbai Cab Service", "Katraj to Mumbai Airport Cab Service"],
    ["Kondhwa to Bandra Cab Service", "Kondhwa to Dadar Cab Service"],
    ["Kondhwa to Mumbai Airport Cabs", "Cab Service in Kondhwa Pune"],
    ["Skyline Cabs Pune", "Pune to Mumbai Airport Cab"],
    ["Pune Mumbai Cab", "Kondhwa to Outstation Cab Service"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Kondhwa to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and timely cab services from Kondhwa to Mumbai, ensuring you reach your destination safely and on time. Whether you’re traveling for work, leisure, or catching a flight, we prioritize your punctuality and comfort every step of the way."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Travel in comfort with Skyline Cabs' fleet of well-maintained vehicles, including sedans, SUVs, and luxury cars. Our cars offer ample space, air-conditioning, and a smooth ride, ensuring you have a relaxing and enjoyable journey from Kondhwa to Mumbai."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are highly experienced and familiar with the best routes from Kondhwa to Mumbai. They are courteous, trained, and background-checked, ensuring that you have a safe, efficient, and pleasant travel experience from start to finish."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers competitive rates with transparent pricing for your Kondhwa to Mumbai trip. You’ll receive clear fare estimates up front with no hidden charges, allowing you to travel with confidence and stay within your budget."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Whether you need an early morning ride or a late-night cab, Skyline Cabs is available 24/7 for your convenience. Our round-the-clock service ensures that you can book a cab from Kondhwa to Mumbai at any time that suits your schedule."
    },
    {
        "WhyChooseheading": "Variety of Vehicles for Every Need",
        "WhyChoosedescription": "Whether you're traveling solo, with a partner, or in a group, we have the perfect vehicle for your trip from Kondhwa to Mumbai. Choose from our wide range of vehicles, including budget-friendly sedans, spacious SUVs, and premium cars for a comfortable and enjoyable ride."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
        "WhyChoosedescription": "Booking a cab from Kondhwa to Mumbai is easy with Skyline Cabs. Our user-friendly website and mobile app make the booking process quick and simple. You’ll receive instant booking confirmation, and you can even track your cab in real time for added convenience."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel Experience",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with GPS for real-time tracking, and our drivers undergo thorough background checks. Enjoy a secure and stress-free ride from Kondhwa to Mumbai with Skyline Cabs."
    }
]















    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Kondhwa to Mumbai with Skyline Cabs?',
            answer:
                'Booking your ride is easy through our website or mobile app. Just select Kondhwa as your pickup location, Mumbai as your drop-off point, and choose your preferred vehicle. Alternatively, you can call our customer service for assistance.',
        },
        {
            id: 2,
            question: 'What types of cabs are available for Kondhwa to Mumbai?',
            answer:
                'We offer a variety of vehicles to suit your needs including sedans, SUVs, Innova, Ertiga, and premium options. Just choose the one that fits your comfort and travel preferences during the booking process.',
        },
        {
            id: 3,
            question: 'Is the fare from Kondhwa to Mumbai fixed?',
            answer:
                'Yes, our fares are fixed and all-inclusive. The total cost includes tolls, taxes, and driver charges. You’ll know the fare upfront with no hidden costs.',
        },
        {
            id: 4,
            question: 'Can I book a round trip from Kondhwa to Mumbai?',
            answer:
                'Yes, you can choose a round-trip booking for your convenience. Simply provide your return details while making your booking, and we’ll take care of the rest.',
        },
        {
            id: 5,
            question: 'How long does it take to travel from Kondhwa to Mumbai?',
            answer:
                'The journey from Kondhwa to Mumbai typically takes 3.5 to 4 hours, depending on traffic conditions. Our drivers are well-acquainted with the best routes to ensure a timely arrival.',
        },
        {
            id: 6,
            question: 'Are your drivers experienced for long-distance travel?',
            answer:
                'Yes, all our drivers are experienced, background-verified, and trained for long-distance routes. They ensure that you have a smooth and safe ride from Kondhwa to Mumbai.',
        },
        {
            id: 7,
            question: 'Can I book a cab for an airport transfer from Kondhwa to Mumbai?',
            answer:
                'Absolutely! We provide reliable airport transfer services from Kondhwa to Mumbai, ensuring you reach Mumbai Domestic or International Airport on time.',
        },
        {
            id: 8,
            question: 'Are the cabs air-conditioned and well-maintained?',
            answer:
                'Yes, all our cabs are air-conditioned and meticulously maintained to ensure maximum comfort. We prioritize cleanliness and hygiene for a pleasant journey.',
        },
        {
            id: 9,
            question: 'Can I make changes or cancel my booking after confirmation?',
            answer:
                'Yes, we have a flexible cancellation and modification policy. You can easily modify or cancel your booking via our app or by contacting our customer support team.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for Kondhwa to Mumbai travel?',
            answer:
                'Skyline Cabs offers transparent pricing, reliable and professional drivers, and a comfortable, stress-free journey. Whether it’s for business, leisure, or airport transfers, we are committed to providing you with the best service.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Anil Patil",
            rating: 5,
            review: "I booked a cab from Kondhwa to Mumbai for a family trip. The vehicle was clean and comfortable, and the driver was friendly and professional. It was a smooth ride all the way!"
        },
        {
            name: "Miss. Snehal Kulkarni",
            rating: 4,
            review: "The ride from Kondhwa to Mumbai was great. The driver arrived on time and made the journey very pleasant. It would be nice to have more charging points in the car, but overall, a good experience."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



  const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kondhwa to Mumbai Cab",
  "image": "https://skylinecabs.com/assets/images/kondhwa-to-mumbai-cab.jpg",
  "description": "Book Kondhwa to Mumbai cab with Skyline Cabs for a convenient, affordable, and comfortable journey. Choose AC sedans or SUVs with verified drivers — available 24/7 for one-way or round trips.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7391"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/kondhwa-to-mumbai-cab"
  }
};



      
    
      

    return (
        <div>

<Helmet>
  <title>Kondhwa to Mumbai Cab | One-Way & Round Trip | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Kondhwa to Mumbai cab with Skyline Cabs for a convenient, affordable, and comfortable journey. Choose AC sedans or SUVs with verified drivers — available 24/7 for one-way or round trips." 
  />
  <meta 
    name="keywords" 
    content="Kondhwa to Mumbai Cab, Cab from Kondhwa to Mumbai, One-Way Taxi Kondhwa to Mumbai, Round Trip Cab Kondhwa Mumbai, AC Cab Kondhwa to Mumbai, SUV Taxi Kondhwa to Mumbai, 24/7 Cab Booking Kondhwa to Mumbai, Skyline Cabs Kondhwa to Mumbai, Affordable Cab Kondhwa to Mumbai, Online Cab Kondhwa to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/69.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Kondhwatomumbaicab;